module.exports = __webpack_public_path__ + "img/jpg.55c53d48.svg";